export default __webpack_public_path__ + "static/media/placeholder_business02-en-mobile.6fe58074.png";